import { connect, ConnectedProps } from 'react-redux'
import { ModalFullCentered, CloseLateralModalSimple } from '../../../../../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../../../../utils/reducers/company/workingCenters'
import { getUserPermissions } from '../../../../../../../../../../utils/reducers/getters'
import TableSellTicketForRefundListing from './TableSellTicketForRefundListing'
import { SetTPVCompleteDataTy, TPVOrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { InputTableURLsTable } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import TwinTrans from '../../../../../../../../../../baseComponents/TwinTrans'

type ModaCreateSellTicketRefundProps = ModalEditComponentProps & ReduxModaCreateSellTicketRefund & {
    setCompleteData: SetTPVCompleteDataTy
    completeData: TPVOrderData
    inputTableURLs: InputTableURLsTable
    handleOnSubmitProcessSellTicketRefund: () => Promise<void>
}

const ModaCreateSellTicketRefund: React.FC<ModaCreateSellTicketRefundProps> = ({ ...rest }) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal input_table_refund' onClickOut={false}>
            <div className='flex items-center'>
                <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
                <SellTicketRefundTitle completeData={rest.completeData}/>
            </div>
            <TableSellTicketForRefundListing userPermissions={getUserPermissions('sell.refundTickets') || { n: 2, permission: 'create' }} {...rest} cashRegister={rest.completeData?.cashRegister} />
        </ModalFullCentered>
    )
}

interface SellTicketRefundTitleProps {
    completeData: TPVOrderData
}

const SellTicketRefundTitle: React.FC<SellTicketRefundTitleProps> = ({ completeData }) => {
    return (
        <h2 className='flex ml-20 mb-30'>
            <span><TwinTrans transKey='ticket'>Ticket</TwinTrans></span>
            <span className='mx-5'>{completeData.header.full_assigned_number}</span>
            {completeData?.header?.CustomerId ? <div className=''><span> - </span><span>{completeData.header.Customer?.fiscal_name}</span></div> : null}
        </h2>
    )
}


const modaCreateSellTicketRefundDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
}

type ReduxModaCreateSellTicketRefund = ConnectedProps<typeof modaCreateSellTicketRefundConnect>
const mapModaCreateSellTicketRefundConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters })
const modaCreateSellTicketRefundConnect = connect(mapModaCreateSellTicketRefundConnector, modaCreateSellTicketRefundDispatch)
const modaCreateSellTicketRefundLoading = withLoading(ModaCreateSellTicketRefund, [{ fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ModaCreateSellTicketRefundConnect = modaCreateSellTicketRefundConnect(modaCreateSellTicketRefundLoading)

export default ModaCreateSellTicketRefundConnect
